export default "__VITE_ASSET__cnA3a8v9__"